export const STAGE_KEYS = { SGI: 'sgiSts', SST: 'sSts', WEB: 'webSts', WST: 'wSts' };

// Maintain sequence - sgiSts, sSts, webSts, wSts
export const STAGE_FILTERS = {
  // Available
  AVAILABLE: { or: { sgiSts: undefined, sSts: undefined, webSts: undefined, wSts: 'A' } },
  AVAILABLE_NOT: { or: { sgiSts: undefined, sSts: undefined, webSts: undefined, wSts: 'NA' } },
  // New Arrival
  NEW_ARRIVAL: { or: { sgiSts: undefined, sSts: undefined, webSts: undefined, wSts: 'B' } },
  // Best Buy
  BEST_BUY: { or: { sgiSts: { nin: ['I'] }, sSts: undefined, webSts: { nin: ['I'] }, wSts: 'D' } },
  BEST_BUY_MEMO: { or: { sgiSts: 'I', sSts: undefined, webSts: 'I', wSts: 'D' } },
  BEST_BUY_MEMO_SGI: { or: { sgiSts: 'I', sSts: undefined, webSts: { nin: ['I'] }, wSts: 'D' } },
  // Hold
  HOLD: { or: { wSts: 'H' } },
  HOLD_SGI: { or: { sgiSts: undefined, sSts: ['Y'], webSts: undefined, wSts: 'H' } },
  HOLD_ORDER_PENDING: { or: { sgiSts: undefined, sSts: undefined, webSts: undefined, wSts: 'C' } },
  // Memo
  MEMO: { or: { sgiSts: 'I', sSts: undefined, webSts: 'I', wSts: ['M', 'D'] } },
  MEMO_SGI: { or: { sgiSts: 'I', sSts: undefined, webSts: { nin: ['I'] }, wSts: ['M', 'D'] } },
};

// Default options
export const STAGE_OPTIONS_DEFAULT = {
  // Available
  ALL: { label: 'All', color: 'transparent' },
  AVAILABLE: { label: 'Available', color: '#6bc950' },
  AVAILABLE_NOT: { label: 'Not Available', color: '#ff960b' },
  // New Arrival
  NEW_ARRIVAL: { label: 'New Arrival', color: '#d2b48c' },
  // Best Buy
  BEST_BUY: { label: 'Best Buy', color: '#ffc0cb' },
  BEST_BUY_MEMO: { label: 'Best Buy/On Memo', color: '#ffc0cb' },
  BEST_BUY_MEMO_SGI: { label: 'Best Buy/SGI memo', color: '#ffc0cb' },
  // Hold
  HOLD: { label: 'On Hold', color: '#db1c1c' },
  HOLD_SGI: { label: 'SGI Hold', color: '#db1c1c' },
  HOLD_ORDER_PENDING: { label: 'Hold/Order Pending', color: '#1c4e7f' },
  // Memo
  MEMO: { label: 'On Memo', color: '#307bea' },
  MEMO_SGI: { label: 'SGI Memo', color: '#307bea' },
};

// Options per page, get from `STAGE_OPTIONS_DEFAULT`
export const STAGE_OPTIONS = {
  DEFAULT: STAGE_OPTIONS_DEFAULT,
  CUSTOMER: {
    ALL: STAGE_OPTIONS_DEFAULT.ALL,
    AVAILABLE: STAGE_OPTIONS_DEFAULT.AVAILABLE,
    // NEW_ARRIVAL: STAGE_OPTIONS_DEFAULT.NEW_ARRIVAL,
    HOLD: STAGE_OPTIONS_DEFAULT.HOLD,
    MEMO: STAGE_OPTIONS_DEFAULT.MEMO,
    BEST_BUY: STAGE_OPTIONS_DEFAULT.BEST_BUY,
  },
};
